/*
 * Русский перевод плагина Scaffolder (раздел «Создать»: список шаблонов, форма, страница
 * задачи, редактор шаблонов) и его React-части (шаги формы, карточка шаблона).
 */
import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react';

const scaffolderRu = createTranslationMessages({
  ref: scaffolderTranslationRef,
  full: false,
  messages: {
    'aboutCard.launchTemplate': 'Запустить шаблон',
    'actionsPage.title': 'Установленные действия',
    'actionsPage.pageTitle': 'Действия шаблонов',
    'actionsPage.subtitle': 'Все действия, доступные в шаблонах',
    'actionsPage.content.emptyState.title': 'Нечего показать',
    'actionsPage.content.emptyState.description':
      'Действия не установлены или бэкенд недоступен.',
    'actionsPage.content.searchFieldPlaceholder': 'Поиск действия',
    'actionsPage.action.input': 'Вход',
    'actionsPage.action.output': 'Выход',
    'actionsPage.action.examples': 'Примеры',
    'fields.entityNamePicker.title': 'Имя',
    'fields.entityNamePicker.description': 'Уникальное имя компонента',
    'fields.entityPicker.title': 'Сущность',
    'fields.entityPicker.description': 'Сущность из каталога',
    'fields.entityTagsPicker.title': 'Тэги',
    'fields.entityTagsPicker.description':
      'Добавьте тэги, Enter — новый тэг. Формат: [a-z0-9+#] через [-], не длиннее 63 символов',
    'fields.multiEntityPicker.title': 'Сущности',
    'fields.multiEntityPicker.description': 'Сущности из каталога',
    'fields.myGroupsPicker.title': 'Группа',
    'fields.myGroupsPicker.description': 'Одна из ваших групп',
    'fields.ownedEntityPicker.title': 'Сущность',
    'fields.ownedEntityPicker.description':
      'Сущность из каталога, которой вы владеете',
    'fields.ownerPicker.title': 'Владелец',
    'fields.ownerPicker.description': 'Владелец компонента',
    'fields.azureRepoPicker.organization.title': 'Организация',
    'fields.azureRepoPicker.organization.description':
      'Организация, в которой будет создан репозиторий',
    'fields.azureRepoPicker.project.title': 'Проект',
    'fields.azureRepoPicker.project.description':
      'Проект, в котором будет создан репозиторий',
    'fields.bitbucketRepoPicker.workspaces.title': 'Доступные workspace',
    'fields.bitbucketRepoPicker.workspaces.inputTitle': 'Workspace',
    'fields.bitbucketRepoPicker.workspaces.description':
      'Workspace, в котором будет создан репозиторий',
    'fields.bitbucketRepoPicker.project.title': 'Доступные проекты',
    'fields.bitbucketRepoPicker.project.inputTitle': 'Проект',
    'fields.bitbucketRepoPicker.project.description':
      'Проект, в котором будет создан репозиторий',
    'fields.gerritRepoPicker.owner.title': 'Владелец',
    'fields.gerritRepoPicker.owner.description':
      'Владелец проекта (необязательно)',
    'fields.gerritRepoPicker.parent.title': 'Родитель',
    'fields.gerritRepoPicker.parent.description':
      'Родительский проект, к которому будет относиться репозиторий',
    'fields.giteaRepoPicker.owner.title': 'Доступные владельцы',
    'fields.giteaRepoPicker.owner.inputTitle': 'Владелец',
    'fields.giteaRepoPicker.owner.description':
      'Пространство Gitea для репозитория: организация, группа, подгруппа, пользователь или проект.',
    'fields.githubRepoPicker.owner.title': 'Доступные владельцы',
    'fields.githubRepoPicker.owner.inputTitle': 'Владелец',
    'fields.githubRepoPicker.owner.description':
      'Организация, пользователь или проект, которому будет принадлежать репозиторий',
    'fields.gitlabRepoPicker.owner.title': 'Доступные владельцы',
    'fields.gitlabRepoPicker.owner.inputTitle': 'Владелец',
    'fields.gitlabRepoPicker.owner.description':
      'Пространство GitLab для репозитория: группа, подгруппа, пользователь или проект.',
    'fields.repoUrlPicker.host.title': 'Хост',
    'fields.repoUrlPicker.host.description':
      'Хост, на котором будет создан репозиторий',
    'fields.repoUrlPicker.repository.title': 'Доступные репозитории',
    'fields.repoUrlPicker.repository.inputTitle': 'Репозиторий',
    'fields.repoUrlPicker.repository.description': 'Имя репозитория',
    'fields.repoOwnerPicker.title': 'Владелец',
    'fields.repoOwnerPicker.description': 'Владелец репозитория',
    'listTaskPage.title': 'Задачи шаблонов',
    'listTaskPage.pageTitle': 'Задачи шаблонов',
    'listTaskPage.subtitle': 'Все запуски шаблонов',
    'listTaskPage.content.emptyState.title': 'Нечего показать',
    'listTaskPage.content.emptyState.description':
      'Задач нет или бэкенд недоступен.',
    'listTaskPage.content.tableTitle': 'Задачи',
    'listTaskPage.content.tableCell.taskID': 'ID задачи',
    'listTaskPage.content.tableCell.template': 'Шаблон',
    'listTaskPage.content.tableCell.created': 'Создана',
    'listTaskPage.content.tableCell.owner': 'Кто запустил',
    'listTaskPage.content.tableCell.status': 'Состояние',
    'ownerListPicker.title': 'Кто запустил',
    'ownerListPicker.options.owned': 'Мои',
    'ownerListPicker.options.all': 'Все',
    'ongoingTask.title': 'Запуск шаблона',
    'ongoingTask.pageTitle.hasTemplateName': 'Запуск «{{templateName}}»',
    'ongoingTask.pageTitle.noTemplateName': 'Запуск шаблона',
    'ongoingTask.subtitle': 'Задача {{taskId}}',
    'ongoingTask.cancelButtonTitle': 'Отменить',
    'ongoingTask.retryButtonTitle': 'Повторить',
    'ongoingTask.startOverButtonTitle': 'Начать заново',
    'ongoingTask.hideLogsButtonTitle': 'Скрыть логи',
    'ongoingTask.showLogsButtonTitle': 'Показать логи',
    'ongoingTask.contextMenu.moreOptions': 'Ещё',
    'ongoingTask.contextMenu.hideLogs': 'Скрыть логи',
    'ongoingTask.contextMenu.showLogs': 'Показать логи',
    'ongoingTask.contextMenu.hideButtonBar': 'Скрыть панель кнопок',
    'ongoingTask.contextMenu.retry': 'Повторить',
    'ongoingTask.contextMenu.showButtonBar': 'Показать панель кнопок',
    'ongoingTask.contextMenu.startOver': 'Начать заново',
    'ongoingTask.contextMenu.cancel': 'Отменить',
    'templateEditorForm.stepper.emptyText':
      'В шаблоне нет параметров для предпросмотра.',
    'renderSchema.tableCell.name': 'Имя',
    'renderSchema.tableCell.title': 'Заголовок',
    'renderSchema.tableCell.description': 'Описание',
    'renderSchema.tableCell.type': 'Тип',
    'renderSchema.tableCell.value': 'Значение',
    'renderSchema.undefined': 'Схема не задана',
    'templatingExtensions.title': 'Расширения шаблонизатора',
    'templatingExtensions.pageTitle': 'Расширения шаблонизатора',
    'templatingExtensions.subtitle':
      'Доступные фильтры, функции и значения шаблонизатора',
    'templatingExtensions.content.emptyState.title': 'Нечего показать',
    'templatingExtensions.content.emptyState.description':
      'Расширений нет или бэкенд недоступен.',
    'templatingExtensions.content.searchFieldPlaceholder': 'Поиск расширения',
    'templatingExtensions.content.filters.title': 'Фильтры',
    'templatingExtensions.content.filters.notAvailable':
      'Фильтры шаблонов не определены.',
    'templatingExtensions.content.filters.metadataAbsent':
      'Описание фильтра недоступно',
    'templatingExtensions.content.filters.schema.input': 'Вход',
    'templatingExtensions.content.filters.schema.arguments': 'Аргументы',
    'templatingExtensions.content.filters.schema.output': 'Выход',
    'templatingExtensions.content.filters.examples': 'Примеры',
    'templatingExtensions.content.functions.title': 'Функции',
    'templatingExtensions.content.functions.notAvailable':
      'Глобальные функции шаблонов не определены.',
    'templatingExtensions.content.functions.metadataAbsent':
      'Описание функции недоступно',
    'templatingExtensions.content.functions.schema.arguments': 'Аргументы',
    'templatingExtensions.content.functions.schema.output': 'Выход',
    'templatingExtensions.content.functions.examples': 'Примеры',
    'templatingExtensions.content.values.title': 'Значения',
    'templatingExtensions.content.values.notAvailable':
      'Глобальные значения шаблонов не определены.',
    'templateTypePicker.title': 'Категории',
    'templateIntroPage.title': 'Управление шаблонами',
    'templateIntroPage.subtitle':
      'Редактируйте, просматривайте и пробуйте шаблоны, формы и свои поля',
    'templateFormPage.title': 'Редактор шаблонов',
    'templateFormPage.subtitle':
      'Редактируйте, просматривайте и пробуйте формы шаблонов',
    'templateCustomFieldPage.title': 'Обзор своих полей',
    'templateCustomFieldPage.subtitle':
      'Редактируйте, просматривайте и пробуйте свои поля формы',
    'templateEditorPage.title': 'Редактор шаблонов',
    'templateEditorPage.subtitle':
      'Редактируйте, просматривайте и пробуйте шаблоны и их формы',
    'templateEditorPage.dryRunResults.title': 'Результаты пробного запуска',
    'templateEditorPage.dryRunResultsList.title': 'Результат {{resultId}}',
    'templateEditorPage.dryRunResultsList.downloadButtonTitle': 'Скачать .zip',
    'templateEditorPage.dryRunResultsList.deleteButtonTitle':
      'Удалить результат',
    'templateEditorPage.dryRunResultsView.tab.files': 'Файлы',
    'templateEditorPage.dryRunResultsView.tab.log': 'Лог',
    'templateEditorPage.dryRunResultsView.tab.output': 'Выход',
    'templateEditorPage.taskStatusStepper.skippedStepTitle': 'Пропущен',
    'templateEditorPage.customFieldExplorer.selectFieldLabel':
      'Выберите расширение поля',
    'templateEditorPage.customFieldExplorer.fieldForm.title': 'Параметры поля',
    'templateEditorPage.customFieldExplorer.fieldForm.applyButtonTitle':
      'Применить',
    'templateEditorPage.customFieldExplorer.fieldPreview.title':
      'Предпросмотр поля',
    'templateEditorPage.customFieldExplorer.preview.title':
      'Спецификация шаблона',
    'templateEditorPage.templateEditorBrowser.closeConfirmMessage':
      'Точно? Несохранённые изменения будут потеряны',
    'templateEditorPage.templateEditorBrowser.saveIconTooltip':
      'Сохранить все файлы',
    'templateEditorPage.templateEditorBrowser.reloadIconTooltip':
      'Перечитать каталог',
    'templateEditorPage.templateEditorBrowser.closeIconTooltip':
      'Закрыть каталог',
    'templateEditorPage.templateEditorIntro.title':
      'Для начала выберите один из вариантов',
    'templateEditorPage.templateEditorIntro.loadLocal.title':
      'Открыть каталог шаблона',
    'templateEditorPage.templateEditorIntro.loadLocal.description':
      'Откройте локальный каталог шаблона, чтобы редактировать его и пробовать запускать.',
    'templateEditorPage.templateEditorIntro.loadLocal.unsupportedTooltip':
      'Работает только в некоторых браузерах на Chromium и по HTTPS',
    'templateEditorPage.templateEditorIntro.createLocal.title':
      'Создать новый шаблон',
    'templateEditorPage.templateEditorIntro.createLocal.description':
      'Создайте локальный каталог шаблона, чтобы редактировать его и пробовать запускать.',
    'templateEditorPage.templateEditorIntro.createLocal.unsupportedTooltip':
      'Работает только в некоторых браузерах на Chromium и по HTTPS',
    'templateEditorPage.templateEditorIntro.formEditor.title':
      'Песочница формы шаблона',
    'templateEditorPage.templateEditorIntro.formEditor.description':
      'Просматривайте и редактируйте форму шаблона — на примере или загрузив шаблон из каталога.',
    'templateEditorPage.templateEditorIntro.fieldExplorer.title':
      'Обзор своих полей',
    'templateEditorPage.templateEditorIntro.fieldExplorer.description':
      'Посмотрите и попробуйте установленные расширения полей формы.',
    'templateEditorPage.templateEditorTextArea.saveIconTooltip':
      'Сохранить файл',
    'templateEditorPage.templateEditorTextArea.refreshIconTooltip':
      'Перечитать файл',
    'templateEditorPage.templateEditorTextArea.emptyStateParagraph':
      'Выберите действие в меню «Файл».',
    'templateEditorPage.templateFormPreviewer.title': 'Загрузить шаблон',
    'templateListPage.title': 'Создать',
    'templateListPage.subtitle':
      'Шаблоны платформы: кластеры, модели, сервисы, хранилища',
    'templateListPage.pageTitle': 'Создать',
    'templateListPage.templateGroups.defaultTitle': 'Шаблоны',
    'templateListPage.templateGroups.otherTitle': 'Другие шаблоны',
    'templateListPage.contentHeader.registerExistingButtonTitle':
      'Зарегистрировать существующий',
    'templateListPage.contentHeader.supportButtonTitle':
      'Создавайте компоненты по стандартным шаблонам платформы: кластеры, модели, сервисы, хранилища.',
    'templateListPage.additionalLinksForEntity.viewTechDocsTitle':
      'Документация',
    'templateWizardPage.title': 'Создать',
    'templateWizardPage.subtitle':
      'Шаблоны платформы: кластеры, модели, сервисы, хранилища',
    'templateWizardPage.pageTitle': 'Создать',
    'templateWizardPage.templateWithTitle': '{{templateTitle}}',
    'templateWizardPage.pageContextMenu.editConfigurationTitle':
      'Редактировать конфигурацию',
    'templateEditorToolbar.customFieldExplorerTooltip': 'Обзор своих полей',
    'templateEditorToolbar.installedActionsDocumentationTooltip':
      'Документация по действиям',
    'templateEditorToolbar.templatingExtensionsDocumentationTooltip':
      'Документация по расширениям шаблонизатора',
    'templateEditorToolbar.addToCatalogButton': 'Опубликовать',
    'templateEditorToolbar.addToCatalogDialogTitle': 'Публикация изменений',
    'templateEditorToolbar.addToCatalogDialogContent.stepsIntroduction':
      'Чтобы создать или обновить шаблон:',
    'templateEditorToolbar.addToCatalogDialogContent.stepsListItems':
      'Сохраните файлы шаблона в локальный каталог\nОткройте merge request в новый или существующий репозиторий\nЕсли шаблон уже есть, изменения попадут в каталог после слияния\nЕсли шаблон новый, зарегистрируйте его репозиторий в каталоге по документации ниже',
    'templateEditorToolbar.addToCatalogDialogActions.documentationButton':
      'Открыть документацию',
    'templateEditorToolbarFileMenu.button': 'Файл',
    'templateEditorToolbarFileMenu.options.openDirectory':
      'Открыть каталог шаблона',
    'templateEditorToolbarFileMenu.options.createDirectory':
      'Создать каталог шаблона',
    'templateEditorToolbarFileMenu.options.closeEditor': 'Закрыть редактор',
    'templateEditorToolbarTemplatesMenu.button': 'Шаблоны',
  },
});

const scaffolderReactRu = createTranslationMessages({
  ref: scaffolderReactTranslationRef,
  full: false,
  messages: {
    'passwordWidget.content':
      'Этот виджет небезопасен. Используйте [`ui:field: Secret`](https://backstage.io/docs/features/software-templates/writing-templates/#using-secrets) вместо `ui:widget: password`',
    'scaffolderPageContextMenu.moreLabel': 'ещё',
    'scaffolderPageContextMenu.createLabel': 'Создать',
    'scaffolderPageContextMenu.editorLabel': 'Управление шаблонами',
    'scaffolderPageContextMenu.actionsLabel': 'Действия шаблонов',
    'scaffolderPageContextMenu.tasksLabel': 'Задачи шаблонов',
    'scaffolderPageContextMenu.templatingExtensionsLabel':
      'Расширения шаблонизатора',
    'stepper.backButtonText': 'Назад',
    'stepper.createButtonText': 'Создать',
    'stepper.reviewButtonText': 'Проверить',
    'stepper.stepIndexLabel': 'Шаг {{index, number}}',
    'stepper.nextButtonText': 'Далее',
    'templateCategoryPicker.title': 'Категории',
    'templateCard.noDescription': 'Без описания',
    'templateCard.chooseButtonText': 'Выбрать',
    'cardHeader.detailBtnTitle': 'Показать сущность шаблона',
    'templateOutputs.title': 'Результат',
    'workflow.noDescription': 'Без описания',
  },
});

export const scaffolderTranslations = [
  createTranslationResource({
    ref: scaffolderTranslationRef,
    translations: { ru: () => Promise.resolve({ default: scaffolderRu }) },
  }),
  createTranslationResource({
    ref: scaffolderReactTranslationRef,
    translations: { ru: () => Promise.resolve({ default: scaffolderReactRu }) },
  }),
];
